import axiosInstance from '@/shared/api/axios';
import type { PaginatedResponse } from '@/shared/types/api/common';
import type {
  ApiSupportBlockResponse,
  ApiSupportConversationDetail,
  ApiSupportConversationListItem,
  ApiSupportConversationsListParams,
  ApiSupportMessage,
  ApiSupportSendMessageBody,
  ApiSupportUnreadCount,
} from '@/shared/types/api/support-chat';

export const apiSupportConversationsGet = async (
  params: ApiSupportConversationsListParams,
): Promise<PaginatedResponse<ApiSupportConversationListItem>> => {
  const { data } = await axiosInstance.get<PaginatedResponse<ApiSupportConversationListItem>>(
    '/support/conversations',
    { params },
  );
  return data;
};

export const apiSupportConversationGet = async (
  userId: string,
): Promise<ApiSupportConversationDetail> => {
  const { data } = await axiosInstance.get<ApiSupportConversationDetail>(
    `/support/conversations/${userId}`,
  );
  return data;
};

export const apiSupportMessageSend = async (
  userId: string,
  body: ApiSupportSendMessageBody,
): Promise<ApiSupportMessage> => {
  const form = new FormData();
  if (body.text) form.append('text', body.text);
  if (body.file) form.append('file', body.file);
  // Let the browser/axios set the multipart boundary by overriding the JSON default.
  const { data } = await axiosInstance.post<ApiSupportMessage>(
    `/support/conversations/${userId}/messages`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
};

export const apiSupportUnreadCountGet = async (): Promise<ApiSupportUnreadCount> => {
  const { data } = await axiosInstance.get<ApiSupportUnreadCount>('/support/unread-count');
  return data;
};

export const apiSupportBlock = async (userId: string): Promise<ApiSupportBlockResponse> => {
  const { data } = await axiosInstance.post<ApiSupportBlockResponse>(
    `/support/conversations/${userId}/block`,
  );
  return data;
};

export const apiSupportUnblock = async (userId: string): Promise<ApiSupportBlockResponse> => {
  const { data } = await axiosInstance.post<ApiSupportBlockResponse>(
    `/support/conversations/${userId}/unblock`,
  );
  return data;
};
